<template>
  <div class="dialog-wrapper">
    <el-dialog
      v-bind="dialogProps"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      append-to-body
    >

      <el-form
        ref="formRef"
        :model="formModel" 
        :rules="rules"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="上级菜单:" prop="parentName">
          <el-input v-model="formModel.parentName" disabled/>
        </el-form-item>

        <el-form-item label="菜单名称:" prop="name">
          <el-input v-model="formModel.name" placeholder="请输入菜单名称" maxlength="32" />
        </el-form-item>

        <el-form-item label="菜单地址:" prop="url">
          <el-input v-model="formModel.url" placeholder="请输入菜单地址" />
        </el-form-item>

        <el-form-item label="资源标识:" prop="code">
          <el-input v-model="formModel.code" placeholder="请输入资源标识" />
        </el-form-item>

        <el-form-item label="数据范围:" prop="scope">
          <el-checkbox-group v-model="formModel.scope">
            <el-checkbox v-for="item in scopeList" :key="item.id" :label="item.id">{{ item.label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="菜单位置:" prop="beforeId">
          <el-select  
            v-model="formModel.beforeId" 
            style="width: 100%"
            clearable 
            filterable 
            placeholder="请选择菜单位置"
          >
            <el-option
              v-for="item in positionList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button type="plain" @click="handleClose">关闭</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
const MODE = ['add', 'edit']
const TITLE = ['新增菜单', ' 编辑菜单']
import Services from '@/services/api/backstage'

export default {
  data() {
    return {
      rules: {
        name: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
        ],
        url: [
          {
            required: true, message: '请输入正确的菜单地址("/"开头仅支持英文和数字)', trigger: ['blur', 'change'], pattern: /^\/[A-Za-z0-9]/, 
          },
        ],
        code: [
          {
            required: true, message: '请输入正确的资源标识("/"开头仅支持英文和数字)', trigger: ['blur', 'change'], 
          },
        ],
        beforeId: [
          { required: true, message: '请选择菜单位置)', trigger: ['blur', 'change'] },
        ],
      },
      dialogProps: {
        visible: false,
        mode: null,
        title: null,
      },
      formModel: {
        parentId: null,
        parentName: null,
        name: null,
        url: null,
        code: null,
        scope: [],
        beforeId: null,
        type: 1, // 写死type 后端需要 1 === 表明是个菜单
      },
      positionList: [],
      scopeList: [
        {
          id: 1,
          label: '个人',
        },
        {
          id: 2,
          label: '团队',
        },
        {
          id: 3,
          label: '团队含下级',
        },
        {
          id: 4,
          label: '全部',
        },
      ],
    };
  },
  mounted() {},
  methods: {
    async handleGetPositionList(id, parentId) {
      const { data } = await Services.apiQueryMenuPosition(id, parentId)
      this.positionList = data.data
    },

    async handleOpen(data, lastMenu) {
      const { name, id } = lastMenu
      await this.handleGetPositionList({ id, parentId: id })
      this.formModel.parentId = id
      this.formModel.parentName = name
      this.dialogProps = {
        visible: true,
        mode: MODE[0],
        title: TITLE[0],
      }
    },

    async handleEdit(menu) {
      await this.handleGetPositionList({ id: menu.id, parentId: menu.parentId })
      const res = await Services.apiQuerySystemTreeDetail({ id: menu.id })
      
      this.dialogProps = {
        visible: true,
        mode: MODE[1],
        title: TITLE[1],
      }
      
      this.$nextTick(() => {
        const { children, ...rest } = res.data
        this.formModel = Object.assign(this.formModel, rest)
      })
    },

    handleClose() {
      this.$refs.formRef.resetFields()
      this.dialogProps = {
        visible: false,
        mode: MODE[0],
        title: TITLE[0],
      }
    },

    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()

        if (this.dialogProps.mode === 'add') {
          await Services.apiAddSystemTree(this.formModel)
        } else {
          await Services.apiUpdateSystemTree(this.formModel)
        }
        this.$message.success('操作成功')
        this.$emit('handle-get-tree-data')
        this.handleClose()
      } catch (error) {
        console.log(error)
      }
    },
  },
};
</script>

<style scoped lang="less"></style>
